import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';
import type { FertilizationPlanReferenceDTO, FertilizationPlanReferencePayload } from './types';

export const useCreateFertilizationPlanReference = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (payload: FertilizationPlanReferencePayload) => {
			try {
				const { data } = await api.post<FertilizationPlanReferenceDTO>(
					'/fertilization-plan-reference/create',
					payload,
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao criar plano de cálculo');
			}
		},
		onSuccess: () => queryClient.invalidateQueries({ queryKey: ['fertilization-plan-reference'] }),
		onError: error =>
			console.error('Erro ao criar plano de cálculo:', getApiErrorMessage(error, 'Erro ao criar plano de cálculo')),
	});
};
